import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getIsAuthenticated } from 'store/user';
const NoAuthRoute = () => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const location = useLocation();
  const from = location.state?.from;
  if (isAuthenticated) {
    if (from) {
      return <Navigate to={from} replace />;
    } else {
      return <Navigate to='/' replace />;
    }
  } else {
    return <Outlet />;
  }
};
export default NoAuthRoute;
